import Heading from 'components/text/Heading';
import Marquee from 'components/Marquee';
import PropTypes from 'prop-types';
import React from 'react';
import { above } from 'utils/mediaqueries';
import { bleedMargins } from 'config/theme/contentMargins';
import styled from 'libs/styled';

const Wrapper = styled('div')`
    width: 100vw;
    overflow-x: hidden;
`;

const Text = styled('p')`
    white-space: nowrap;
    font-size: 5.6rem;
    font-weight: 500;
    line-height: 1.1;
    letter-spacing: -0.03em;

    &::after {
        display: inline-block;
        content: '—';
        margin: 0px 0.5em;
    }

    ${above.sm} {
        font-size: 11.2rem;
    }

    ${above.xl} {
        font-size: 14.4rem;
    }
`;

/**
 * Display a revolving text or heading.
 *
 * @param {string} heading - Heading as a string.
 * @param {bool} [revolving=true] - Turn on/off revolving text..
 * @param {string} textColor - The color of the text.
 */

const SalePromotion = ({ heading, revolving = true, textColor }) => {
    if (!revolving) {
        return (
            <Heading as="h2" color={textColor} size="xl">
                {heading}
            </Heading>
        );
    }

    return (
        <Wrapper marginLeft={bleedMargins}>
            <Marquee speed={30}>
                <Text color={textColor}>{heading}</Text>
            </Marquee>
        </Wrapper>
    );
};

SalePromotion.propTypes = {
    heading: PropTypes.string.isRequired,
    revolving: PropTypes.bool,
    textColor: PropTypes.string.isRequired,
};

export default SalePromotion;
